import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { validate } from 'uuid';

import { createActiv8ProjectYupValidation } from '../validation';
import Activ8CreationForm from './Activ8CreationForm';
import { createActiv8Project } from '../../../redux/projects/projectsActions';

function Activ8Creation() {
  const dispatch = useDispatch();

  const createActiv8ProjectInitialValues = {
    projectName: '',
    assignUser: '',
    activeUsers: [],
  };

  const handleCreateProject = (values) => {
    dispatch(createActiv8Project(values));
  };

  return (
    <Form
      initialValues={createActiv8ProjectInitialValues}
      onSubmit={handleCreateProject}
      validate={(values) => validate(values, createActiv8ProjectYupValidation())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <Activ8CreationForm handleSubmit={handleSubmit} />}
    />
  );
}

export default Activ8Creation;
